import { Customer } from "../customer/customer-model";
import { WithDrawalsViewModel } from "./withdrawals-view";
import { WithdrawalsPurchaseOrder } from "./withdrawals-purchase-order.models";
import { AdminOrderDetail } from "../PurchaseOrder/create-purchase-order.model";

export class WithdrawalsViews {

  public customer: Customer;
  public withdrawalRequest: WithDrawalsViewModel;
  public withdrawalsPurchaseOrders: WithdrawalsPurchaseOrder[];
  public purchaseOrdersDetails: AdminOrderDetail[];

}



// WEBPACK FOOTER //
// ./src/app/models/Withdrawals/withdrawals-view.models.ts